// extracted by mini-css-extract-plugin
export default {"about":"About_about__H5-sJ","wrapper":"About_wrapper__Icz9Q","title":"About_title__Zmif+","summary":"About_summary__bqrv0"};